import { render, staticRenderFns } from "./LiveDebug.vue?vue&type=template&id=09b929b1&scoped=true"
import script from "./LiveDebug.vue?vue&type=script&lang=js"
export * from "./LiveDebug.vue?vue&type=script&lang=js"
import style0 from "./LiveDebug.vue?vue&type=style&index=0&id=09b929b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b929b1",
  null
  
)

export default component.exports